import { render, staticRenderFns } from "./ConsumptionOverview.vue?vue&type=template&id=873f0bbe"
import script from "./ConsumptionOverview.vue?vue&type=script&lang=js"
export * from "./ConsumptionOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports